import './style.css'

export default function InfoPopup({ info, onClose }) {
  const handleInnerClick = (e) => {
    // Allow clicks on the "Read more" button to work normally
    if (e.target.closest('.read-more-button')) return;

    // Otherwise, close when clicking anywhere inside
    onClose();
  };

  return (
    <div className="info-popup-overlay" onClick={onClose}>
      <div className="info-popup-content" onClick={handleInnerClick}>
        <h2>{info.title}</h2>
        <p className='info-text'>{info.description}</p>
        <button
          onClick={() => window.open(info.url, '_blank', 'noopener,noreferrer')}
          className="read-more-button"
        >
          Read more
        </button>
      </div>
    </div>
  );
}
